/* 
用户中心
*/
import APIDOC from '../model/serverApi';
import {get, post} from '../model/request';


export function user_getUser(){
    return get("./mockURL")
}



// WEBPACK FOOTER //
// ./src/api/services/user.js